import { PhaseLayout } from "../../components/PhaseLayout";
import { StepGenerator } from "../../components/StepGenerator";

const STEPS = [
  {
    type: "launch_timeline",
    title: "Launch Timeline",
    description: "Plan a calm, sustainable launch without burnout.",
    fields: [
      { key: "product", label: "Product Name", placeholder: "e.g., Business Blueprint Course", required: true },
      { key: "date", label: "Target Launch Date", placeholder: "e.g., March 15, 2026", required: true },
      { key: "audience", label: "Current Audience Size", placeholder: "e.g., 1000 email subscribers", required: true },
      { key: "energy", label: "Your Energy Level", placeholder: "e.g., High energy, moderate - need rest days built in, recovering from burnout", required: true }
    ]
  },
  {
    type: "pricing_strategy",
    title: "Pricing Strategy",
    description: "Set confident pricing that reflects your value.",
    fields: [
      { key: "value", label: "Value Delivered", placeholder: "e.g., Complete business framework, 6 weeks of content, templates", required: true, type: "textarea" },
      { key: "market", label: "Market Research", placeholder: "e.g., Similar courses priced $297-$997, mine offers more 1:1 support", required: true, type: "textarea" },
      { key: "experience", label: "Your Experience Level", placeholder: "e.g., 5 years in field, 100+ clients served", required: true },
      { key: "budget", label: "Ideal Customer Budget", placeholder: "e.g., Can invest $500-$2000 in business growth", required: true }
    ]
  },
  {
    type: "objection_handler",
    title: "Objection Handler",
    description: "Prepare confident responses to common purchase hesitations.",
    fields: [
      { key: "product", label: "Your Product", placeholder: "e.g., 6-week course on launching digital products", required: true },
      { key: "price", label: "Price Point", placeholder: "e.g., $597", required: true },
      { key: "hesitations", label: "Common Hesitations You Hear", placeholder: "e.g., 'I don't have time', 'It's too expensive', 'I'm not ready'", required: true, type: "textarea" },
      { key: "buyer", label: "Target Buyer Profile", placeholder: "e.g., Service provider wanting to add passive income", required: true }
    ]
  },
  {
    type: "launch_copy",
    title: "Launch Copy Generator",
    description: "Create compelling sales page and email copy.",
    fields: [
      { key: "product_name", label: "Product Name", placeholder: "e.g., The Calm Business Blueprint", required: true },
      { key: "benefits", label: "Key Benefits", placeholder: "e.g., Clarity, confidence, consistent income without burnout", required: true, type: "textarea" },
      { key: "transformation", label: "Before/After Transformation", placeholder: "e.g., From scattered to systematic, from overwhelmed to organized", required: true, type: "textarea" },
      { key: "urgency", label: "Urgency Element (if any)", placeholder: "e.g., Limited spots, founding member pricing, bonus deadline", required: false }
    ]
  }
];

export default function LaunchPhase() {
  return (
    <PhaseLayout 
      phaseNumber={4}
      phaseName="Launch"
      phaseSubtitle="Go Live Calmly"
      phaseDescription="Prepare for a sustainable, stress-free launch that honors your energy. This is the final phase of your 14-day blueprint."
      days="Days 11-14"
      nextPhase={null}
      prevPhase={{ number: 3, name: "Authority", path: "/phase/authority" }}
    >
      {STEPS.map((step, index) => (
        <StepGenerator
          key={step.type}
          room="launch"
          generatorType={step.type}
          stepNumber={index + 1}
          title={step.title}
          description={step.description}
          fields={step.fields}
          defaultOpen={index === 0}
        />
      ))}
    </PhaseLayout>
  );
}
